import { Component, Input, OnInit } from '@angular/core';
import { tap } from 'rxjs/operators';

import {
    takeUntilDestroy,
    TakeUntilDestroy,
} from '../../../common/take-until-destroy.decorator';
import { useSelector2 } from '../../store-use-selector';
import { BlFocus } from '../core';
import { BlDialogService, BlDialogState } from '../dialog';

import { TranslationKeyMap } from './bl-button.i18n';

@Component({
    selector: 'cmps-coaching-bl-button',
    templateUrl: './bl-button.component.html',
    host: {
        class: 'cmps-coaching-bl-button',
        '[class.cmps-coaching-bl-button--enabled]': '_hasDocument',
    },
})
@TakeUntilDestroy()
export class BlButtonComponent implements OnInit {
    @Input()
    get focus(): BlFocus {
        return this._focus;
    }

    set focus(value: BlFocus) {
        this._focus = value;
        this._check();
    }

    /** @private */
    _i18n = TranslationKeyMap;

    /** @private */
    _hasDocument: boolean;

    private _focus: BlFocus;

    constructor(private readonly _dialogService: BlDialogService) {}

    ngOnInit(): void {
        useSelector2(
            (state) =>
                (state?.coaching?.behaviourLibrary as BlDialogState)?.focuses,
        )
            .pipe(
                tap(() => {
                    this._check();
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }

    /** @private */
    _onClick($event: Event): void {
        $event?.stopPropagation();
        this._dialogService.open(this.focus);
    }

    private _check(): void {
        this._hasDocument =
            this._focus?.behaviourId != null &&
            this._dialogService.state?.focuses?.some(
                (e) =>
                    e.behaviourId === this._focus.behaviourId &&
                    ((e.subBehaviourId == null &&
                        this._focus.subBehaviourId == null) ||
                        e.subBehaviourId === this._focus.subBehaviourId),
            );
    }
}
